var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFriends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "49356EC6-11AA-40A2-A5EB-C6DFEA031787") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-page-Full",
    transform: "translate(-261, -887)",
    stroke: "#256BFD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Audience",
    transform: "translate(24, 494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Secret-Fans-Copy-5",
    transform: "translate(171, 361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/icons_24/Friends",
    transform: "translate(66, 32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2, 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,12 C6,12 7.5,14 10,14 C12.5,14 14,12 14,12 M15,7.24 C14.605,7.725 14.065,8 13.5,8 C12.935,8 12.41,7.725 12,7.24 M8,7.24 C7.605,7.725 7.065,8 6.5,8 C5.935,8 5.41,7.725 5,7.24 M20,10 C20,15.5228 15.5228,20 10,20 C4.47715,20 0,15.5228 0,10 C0,4.47715 4.47715,0 10,0 C15.5228,0 20,4.47715 20,10 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriends);
export default __webpack_public_path__ + "static/media/friends.8fe537962971b8bb7cb5a918ecbe2dc4.svg";
export { ForwardRef as ReactComponent };